var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFedEx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 24,
    viewBox: "0 0 80 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2912_16136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.491 23.2817L66.1626 15.8925L59.491 8.5022H66.5303L69.8346 12.0919L73.0165 8.5022H79.8103L73.1703 15.862L79.9014 23.2817H72.8332L69.5588 19.6625L66.3153 23.2817H59.491Z",
    fill: "#6C6C6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.491 5.18914H51.9348V8.50217H59.491V13.4952H51.9348V18.0782H59.491V23.2817H46.3811V0H59.491V5.18914Z",
    fill: "#6C6C6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8508 0V9.528H40.7899C39.5656 8.1408 38.0358 7.65874 36.2609 7.65874C32.625 7.65874 29.8863 10.0951 28.9249 13.3162C27.8285 9.76697 25.001 7.59223 20.8083 7.59223C17.4035 7.59223 14.7148 9.09874 13.3117 11.5536V8.50251H6.27374V5.18983H13.9541V0H0V23.2821H6.27374V13.4952H12.527C12.3405 14.2142 12.241 14.9839 12.241 15.7961C12.241 20.6527 16.0049 24.0603 20.8083 24.0603C24.8477 24.0603 27.5096 22.1911 28.9176 18.7831H23.5412C22.8139 19.8069 22.2623 20.111 20.8083 20.111C19.1224 20.111 17.6689 18.661 17.6689 16.9423H28.6164C29.0911 20.7998 32.1395 24.1265 36.3228 24.1265C38.1273 24.1265 39.7795 23.2515 40.7899 21.7742H40.8508V23.2814H46.3812V0H40.8508ZM17.8435 13.5648C18.1924 12.0861 19.3558 11.1195 20.8083 11.1195C22.4073 11.1195 23.5117 12.0562 23.8021 13.5648C23.9245 13.5648 17.8435 13.5648 17.8435 13.5648ZM37.4946 19.7369C35.456 19.7369 34.1892 17.8646 34.1892 15.9096C34.1892 13.8199 35.2911 11.8104 37.4946 11.8104C39.7795 11.8104 40.6897 13.8199 40.6897 15.9096C40.6894 17.8913 39.7249 19.7369 37.4946 19.7369Z",
    fill: "#6C6C6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2912_16136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFedEx);
export default __webpack_public_path__ + "static/media/fedEx.4531e510c582b2773024e251602edbd2.svg";
export { ForwardRef as ReactComponent };